import { Helmet } from 'react-helmet-async'

// Tek kaynaklı sayfa-başı SEO meta'sı. Kanonik URL **trailing slash içermez** —
// sitemap.xml, prerender.mjs ROUTES ve buradaki `path` üçü birebir aynı yazılmalı;
// aksi halde nginx'in dizin yönlendirmesi Google'a "Redirect error" verir.

const SITE_URL = 'https://sign.wsoft.tr'
const SITE_NAME = 'W.Sign'
const DEFAULT_IMAGE = `${SITE_URL}/og.png`

type SeoHeadProps = {
  title: string
  description: string
  path: string
  image?: string
  type?: 'website' | 'article' | 'product'
  /** Portal / imza oturumu gibi indexlenmemesi gereken sayfalar için. */
  noindex?: boolean
  jsonLd?: Record<string, unknown> | Record<string, unknown>[]
}

export default function SeoHead({
  title,
  description,
  path,
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false,
  jsonLd,
}: SeoHeadProps) {
  const url = path.startsWith('http') ? path : `${SITE_URL}${path}`
  const ldBlocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <link rel="canonical" href={url} />
      )}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {ldBlocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  )
}

/** Sitede tekrar eden kurumsal kimlik bloğu — JSON-LD `publisher`/`provider` alanlarında kullanılır. */
export const ORGANIZATION_LD = {
  '@type': 'Organization',
  name: 'WSOFT Yazılım',
  url: 'https://wsoft.tr',
  logo: `${SITE_URL}/logo.svg`,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Ankara',
    addressCountry: 'TR',
  },
} as const
